/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import ErrorBoundary from 'base/components/ErrorBoundary';
import LabradorLabradorImage from 'base/components/labrador/LabradorImage';

export const DynamicLabradorLabradorImage: typeof LabradorLabradorImage = (props) => {
    return <ErrorBoundary><LabradorLabradorImage {...props} /></ErrorBoundary>;
}
export type DynamicLabradorLabradorImageProps = PropsFromComponent<typeof LabradorLabradorImage>;
